import { cn } from '@/lib/utils'
import { Chip, StatusChip } from '@/ui/components'
import React, { memo } from 'react'

export interface TourBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  difficulty?: 'UNKNOWN' | 'EASY' | 'INTERMEDIATE' | 'DIFFICULT'
  isStatusClosed?: boolean
  isStatusOpen?: boolean
  difficultyLabel?: string
  isRelative?: boolean
  framed?: boolean
  showOpenStatus?: boolean
}

const TourBadge = ({
  difficulty,
  isStatusClosed,
  isStatusOpen,
  difficultyLabel,
  className,
  isRelative,
  framed = true,
  showOpenStatus = true,
  ...props
}: TourBadgeProps) => {
  const classComposer = cn(
    'flex text-neutral-100',
    isRelative
      ? 'relative border-r border-r-neutral-300'
      : 'absolute bottom-0 left-0',
    framed && 'bg-neutral-100 pt-xs pr-xs gap-x-xs',
    className
  )

  const difficultyComposer = cn(
    'size-6!',
    difficulty === 'EASY' && 'text-[rgb(12,110,180)]',
    difficulty === 'INTERMEDIATE' && 'text-[rgb(224,2,24)]',
    difficulty === 'DIFFICULT' && 'text-[rgb(10,10,10)]'
  )

  if (!difficulty || !showOpenStatus) {
    return null
  }

  return (
    <div className={classComposer} {...props}>
      {showOpenStatus && (isStatusClosed === true || isStatusOpen === true) && (
        <StatusChip
          variant="fill"
          status={isStatusClosed === true ? 'error' : 'success'}
        />
      )}
      {difficulty !== 'UNKNOWN' && (
        <Chip
          size="s"
          variant="outline"
          iconLeft="octicon:dot-fill-24"
          className="capitalize"
          iconClassName={difficultyComposer}
        >
          {difficultyLabel}
        </Chip>
      )}
    </div>
  )
}

export default memo(TourBadge)
